<template>
    <v-row dense class="ma-0">
        <v-col cols="6" class="py-1 px-1">
            <v-card
                outlined
                :class="{
                    'table-user-mode-card--active': selectedUserMode === tableUserModes.SERVICE,
                    'table-user-mode-card--disabled': controlsDisabled
                }"
                @click="switchUserMode(tableUserModes.SERVICE)"
                @keydown.enter="switchUserMode(tableUserModes.SERVICE)"
                @keydown.space.prevent="switchUserMode(tableUserModes.SERVICE)"
                role="button"
                :aria-disabled="controlsDisabled ? 'true' : 'false'"
                :tabindex="controlsDisabled ? -1 : 0">
                <v-card-text class="d-flex flex-row align-center px-4 py-2">
                    <v-icon large class="mr-3" :color="selectedUserMode === tableUserModes.SERVICE ? 'primary' : ''">mdi-briefcase-account-outline</v-icon>
                    <span class="text-button" :class="selectedUserMode === tableUserModes.SERVICE ? 'primary--text' : ''">Service mode</span>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6" class="py-1 px-1">
            <v-card
                outlined
                :class="{
                    'table-user-mode-card--active': selectedUserMode === tableUserModes.USER,
                    'table-user-mode-card--disabled': controlsDisabled
                }"
                @click="switchUserMode(tableUserModes.USER)"
                @keydown.enter="switchUserMode(tableUserModes.USER)"
                @keydown.space.prevent="switchUserMode(tableUserModes.USER)"
                role="button"
                :aria-disabled="controlsDisabled ? 'true' : 'false'"
                :tabindex="controlsDisabled ? -1 : 0">
                <v-card-text class="d-flex flex-row align-center px-4 py-2">
                    <v-icon large class="mr-3" :color="selectedUserMode === tableUserModes.USER ? 'primary' : ''">mdi-account-circle-outline</v-icon>
                    <span class="text-button" :class="selectedUserMode === tableUserModes.USER ? 'primary--text' : ''">User mode</span>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { enumsData } from '@/mixins/enums'

export default {
    name: 'TableUserModeSwitch',
    mixins: [enumsData],
    data() {
        return {
            selectedUserMode: -1,
            isSwitchingMode: false
        }
    },
    computed: {
        ...mapState(['userInfo', 'fetchingUserInfo']),
        ...mapState('userStore', ['settingTableUserMode']),
        controlsDisabled() {
            return (
                this.fetchingUserInfo ||
                this.settingTableUserMode ||
                this.isSwitchingMode ||
                this.selectedUserMode === -1 ||
                this.userInfo.sf_user_type === this.tableUserModes.NONE
            )
        }
    },
    methods: {
        async switchUserMode(mode) {
            if (this.controlsDisabled) return
            const currentMode = this.userInfo.sf_user_type === this.tableUserModes.SERVICE ? this.tableUserModes.SERVICE : this.tableUserModes.USER
            if (mode === currentMode) return

            this.isSwitchingMode = true
            this.$emit('mode-switch-start')
            try {
                await this.$store.dispatch('userStore/setTableUserMode', mode)
            } finally {
                this.isSwitchingMode = false
                this.$emit('mode-switch-end')
            }
        }
    },
    watch: {
        userInfo: {
            handler(info) {
                if (info.sf_user_type === this.tableUserModes.NONE) return

                switch (info.sf_user_type) {
                    case this.tableUserModes.SERVICE:
                        this.selectedUserMode = this.tableUserModes.SERVICE
                        break
                    case this.tableUserModes.USER:
                    case this.tableUserModes.LEGACY:
                        this.selectedUserMode = this.tableUserModes.USER
                        break
                    default:
                        break
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
.table-user-mode-card--active {
    border-color: var(--v-primary-base) !important;
}

.table-user-mode-card--disabled {
    opacity: 0.6;
    pointer-events: none;
}
</style>
